export default "__VITE_ASSET__D6H7Y3sP__"